import { injectable } from 'tsyringe';

// -------------------------------------------------------------
@injectable()
export class OWTrackRSWrapper {
  // -------------------------------------------------------------
  public trackRSEvent(name: string, extraData: any, overrides: any): Window {
    return overwolfInternal.trackRSEvent(name, extraData, overrides);
  }

  // -------------------------------------------------------------
  public trackRSEventV2(name: string, extraData: any, overrides: any): Window {
    return overwolfInternal.trackRSEventV2(name, extraData, overrides);
  }
}
